export default __webpack_public_path__ + "static/media/AXA.9cd7cdc3.png";